<template>
    <div class="modalBg d-flex flex-column align-items-center justify-content-center" @click.self="handleBackgroundClick">
        <div class="modalContent p-3">
            <!-- Title -->
            <h3 class="text-center bold">Create invoice</h3>
            <span class="d-flex justify-content-center mt-2">{{ this.selectedDocumentType.label }}</span>

            <div v-if="getIsDownloadingInvoiceResume" class="d-flex w-100 justify-content-center my-4">
                <loader></loader>
            </div>

            <!-- Invoice To Selctor -->
            <!-- TODO: Validar com adriana questão das otas para o btn agents -->
            <div v-else class="mt-2 d-flex">
                <button @click="setInvoiceTo('customer')" 
                    :class="{ 'blue': invoiceTo == 'customer' }"
                    class="btn tertiary full super mr-3"
                >Customer</button>
                
                <button @click="setInvoiceTo('agent')" 
                    :class="{ 'blue': invoiceTo == 'agent' }" 
                    class="btn tertiary full super"
                    :disabled="!enableAgentBtn"
                >Agent</button>
            </div>

            <div v-if="invoiceTo" class="row mt-3 mb-4">
                <div class="col-sm-6">
                    <div class="d-flex justify-content-between">
                        <label>
                            Amount to Invoice<span v-if="isDocTypeInvoice" class="color-6">*</span>
                        </label>
                    </div>

                    <div class="d-flex flex-row align-items-center">
                        <input 
                            type="text" 
                            class="fs-large w-100 text-right bg-lighter glued-right amount-input-height"
                            :value="formatPrice(valueToInvoice)"
                            :disabled="true">
                        <div class="glued-left fs-larger bold d-flex align-items-center amount-input-height">€</div>
                    </div>
                </div>

                <div class="col-sm-6" :class="{ error: $v.invoiceToForm.country.$invalid }">
                    <div class="d-flex justify-content-between">
                        <label>
                            Payment Type <span class="color-6">*</span>
                        </label>

                        <div v-if="$v.selectedPaymentType.$invalid" class="messages fs-smaller error">
                            <span v-if="!$v.selectedPaymentType.required">Required</span>
                        </div>
                    </div>

                    <v-select 
                        :options="getPaymentTypes" 
                        v-model="selectedPaymentType"
                        :disabled="getIsPaymentTypesLoading || getIsCreatingInvoice"
                        placeholder="Select Payment Type" 
                        label="label"
                    ></v-select>
                </div>
            </div>

            <!-- Value to invoice & Agent Picker -->
            <div v-if="invoiceTo" class="mt-2 d-flex justify-content-end border-bottom-light">
                <div class="mb-2">
                    <label class="mr-3">
                        <span>Due to Invoice</span>
                    </label>

                    <span class="fs-large font-weight-600" :class="{'color-3': invalidInvoiceValue}">{{ formatPrice(valueToInvoice) }} €</span>
    
                    <label class="mx-3">
                        Total
                    </label>
                    <span class="fs-large font-weight-600">{{ formatPrice(reservation.billingTotal) }} €</span>
                </div>
            </div>
            
            <!-- Billing Info Form -->
            <div v-if="invoiceTo && !getIsPrimaveraSettingsLoading" class="row mt-4">
                <div class="col-sm-6" :class="{ error: $v.invoiceToForm.businessName.$invalid }">
                    <div class="d-flex justify-content-between">
                        <label>
                            Invoice Name <span class="color-6">*</span>
                        </label>

                        <div v-if="$v.invoiceToForm.businessName.$invalid" class="messages fs-smaller">
                            <span v-if="!$v.invoiceToForm.businessName.required">Required</span>
                        </div>
                    </div>

                    <input 
                        type="text" 
                        class="full" 
                        v-model="invoiceToForm.businessName"
                        :disabled="getIsCreatingInvoice"
                    >
                </div>

                <div class="col-sm-6" :class="{ error: $v.invoiceToForm.address.$invalid }">
                    <div class="d-flex justify-content-between">
                        <label>
                            Address <span v-if="isDocTypeInvoice" class="color-6">*</span>
                        </label>

                        <div v-if="$v.invoiceToForm.address.$invalid" class="messages fs-smaller">
                            <span v-if="!$v.invoiceToForm.address.required">Required</span>
                        </div>
                    </div>

                    <input 
                        type="text" 
                        class="full" 
                        v-model="invoiceToForm.address" 
                        :disabled="getIsCreatingInvoice">
                </div>
                
                <div class="col-sm-3 mt-3" :class="{ error: $v.invoiceToForm.vat.$invalid }">
                    <div class="d-flex justify-content-between">
                        <label>
                            VAT Number <span v-if="isDocTypeInvoice" class="color-6">*</span>
                        </label>

                        <div v-if="$v.invoiceToForm.vat.$invalid" class="messages fs-smaller">
                            <span v-if="!$v.invoiceToForm.vat.required">Required</span>
                        </div>
                    </div>

                    <input 
                        type="text"
                        class="full" 
                        v-model="invoiceToForm.vat" 
                        :disabled="getIsCreatingInvoice"
                        @input="$v.invoiceToForm.vat.$touch"
                    >
                </div>

                <div class="col-sm-3 mt-3" :class="{ error: $v.invoiceToForm.city.$invalid }">
                    <div class="d-flex justify-content-between">
                        <label>
                            City <span v-if="isDocTypeInvoice" class="color-6">*</span>
                        </label>

                        <div v-if="$v.invoiceToForm.city.$invalid" class="messages fs-smaller">
                            <span v-if="!$v.invoiceToForm.city.required">Required</span>
                        </div>
                    </div>

                    <input 
                        type="text" 
                        class="full" 
                        v-model="invoiceToForm.city" 
                        :disabled="getIsCreatingInvoice"
                    >
                </div>

                <div class="col-sm-3 mt-3" :class="{ error: $v.invoiceToForm.postalCode.$invalid }">
                    <div class="d-flex justify-content-between">
                        <label>
                            Postal Code <span v-if="isDocTypeInvoice" class="color-6">*</span>
                        </label>

                        <div v-if="$v.invoiceToForm.postalCode.$invalid" class="messages fs-smaller">
                            <span v-if="!$v.invoiceToForm.postalCode.required">Required</span>
                        </div>
                    </div>

                    <input 
                        type="text" 
                        class="full" 
                        v-model="invoiceToForm.postalCode" 
                        :disabled="getIsCreatingInvoice"
                    >
                </div>

                <div class="col-sm-3 mt-3" :class="{ errorSelect: $v.invoiceToForm.country.$invalid }">
                    <div class="d-flex justify-content-between">
                        <label>
                            Country <span v-if="isDocTypeInvoice" class="color-6">*</span>
                        </label>

                        <div v-if="$v.invoiceToForm.country.$invalid" class="messages fs-smaller error">
                            <span v-if="!$v.invoiceToForm.country.required">Required</span>
                        </div>
                    </div>

                    <country-picker :openDirection="'top'" :selectedCountryValue="selectedCountry" :disabled="false" :allowEmpty="false" @input="updateCountry($event)"></country-picker>
                </div>
            </div>

            <div v-if="getIsPrimaveraSettingsLoading"
                 class="d-flex justify-content-center align-items-center">
                <loader size="big"></loader>
            </div>

            <!-- Buttons -->
            <div v-if="invoiceTo" class="mt-5 text-right d-flex w-100 justify-content-end align-items-center">
                <button class="btn tertiary" 
                    :disabled="getIsCreatingInvoice" 
                    @click="closeModal"
                >Cancel</button>

                <button class="btn ml-2"
                    :disabled="invalidInvoiceValue || getIsCreatingInvoice || getIsPrimaveraSettingsLoading || $v.$invalid"
                    @click="createInvoice(false)"
                >Create</button>
                
                <button class="btn ml-2" 
                    :disabled="invalidInvoiceValue || getIsCreatingInvoice || getIsPrimaveraSettingsLoading || $v.$invalid"
                    @click="createInvoice(true)"
                >Create and Print</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required, requiredIf } from 'vuelidate/lib/validators'

import extendedVSelect from '@/extends/vue-select'
import SellerPicker from '@/tools/SellerPicker'
import Loader from '@/tools/loaders/loader1'
import CountryPicker from '@/tools/CountryPicker'

export default {
    data() {
        return {
            printInvoiceCheck: false,
            invoiceTo: null,
            selectedCountry: null,
            selectedAgent: null,
            invoiceToForm: {
                vat: null,
                city: null,
                country: null,
                businessName: null,
                address: null,
                postalCode: null
            },
            invoiceResume: null,
            selectedDocumentType: null,
            selectedPaymentType: null
        }
    },
    computed: {
        ...mapGetters([
            'getCountries',
            'getAgents',
            'getIsDownloadingInvoiceResume',
            'getIsCreatingInvoice',
            'getValueToAskMoreBillingInfo',
            'account',
            'getSelectedDocumentType',
            'getIsPrimaveraSettingsLoading',
            'getPaymentTypes',
            'getIsPaymentTypesLoading'
        ]),
        isDocTypeInvoice() {
            return this.getSelectedDocumentType.id === 'FA';
        },
        enableAgentBtn() {
            return this.reservation.creatorAgent || (this.invoiceResume && this.invoiceResume.isOTA);
        },
        valueToInvoice() {
            if (this.getIsDownloadingInvoiceResume || !this.invoiceResume) {
                return false;
            }

            if (this.invoiceTo == 'customer') {
                return this.invoiceResume.invoiceRequestCustomer.total;
            } else if (this.invoiceTo == 'agent') {
                return this.invoiceResume.invoiceRequestAgent.total;
            }
        },
        invalidInvoiceValue() {
            return this.valueToInvoice <= 0;
        }
    },
    validations: {
        invoiceToForm: {
            vat: {
                required: requiredIf(function () {return this.isDocTypeInvoice})
            },
            city: {
                required: requiredIf(function () {return this.isDocTypeInvoice})
            },
            country: {
                required: requiredIf(function () {return this.isDocTypeInvoice})
            },
            businessName: {
                required
            },
            address: {
                required: requiredIf(function () {return this.isDocTypeInvoice})
            },
            postalCode: {
                required: requiredIf(function () {return this.isDocTypeInvoice})
            }
        },
        selectedPaymentType: {
                required
            },
    },
    props: {
        reservation: {
            type: Object
        }
    },
    created() {
        this.selectedDocumentType = this.getSelectedDocumentType;

        // Download invoice value
        this.downloadReservationInvoiceResume({reservationId: this.reservation.id, docType: this.selectedDocumentType.id}).then(response => {
            if (response.serverInfo.type > 1) {
                this.closeModal();
            } else {
                this.invoiceResume = response.data;
            }
        }).catch(() => {
            this.closeModal();
        });

        if (this.getPaymentTypes.length === 0) this.requestPaymentTypes();        
    },
    methods: {
        ...mapActions([
            'downloadReservationInvoiceResume',
            'emitInvoice',
            'updateExistingReservation',
            'printInvoice',
            'requestPrimaveraSettings',
            'requestPaymentTypes'
        ]),
        handleBackgroundClick(event) {
            const selectedText = window.getSelection().toString();

            if (selectedText.length > 0) {
                return;
            } else {
                this.closeModal();
            }
        },
        closeModal() {
            this.$emit('toggleInvoiceModal');
        },
        setInvoiceTo(invoiceTypeSelected) {
            this.invoiceTo = invoiceTypeSelected;

            this.fillInvoiceForm(invoiceTypeSelected);
        },
        fillInvoiceForm(invoiceTypeSelected) {
            const invoiceType = invoiceTypeSelected === 'customer' ? 'invoiceRequestCustomer' : 'invoiceRequestAgent';
            const invoice = this.invoiceResume[invoiceType].cliente;
            
            if (invoice) {
                this.invoiceToForm = {
                    id: invoice.id || 0,
                    vat: invoice.taxNumber || '',
                    city: invoice.location || '',
                    country: invoice.countryId === 0 ? null : invoice.countryId,
                    businessName: invoice.name || '',
                    address: invoice.address || '',
                    postalCode: invoice.postalCode || '',
                }
                
                this.setCountry(invoice.countryId);
            }
        },
        createInvoice(isToPrint) {
            let self = this;

            if (this.invoiceTo === 'agent' && 
               (this.invoiceToForm.vat === null || this.invoiceToForm.vat === '') && 
               (this.invoiceToForm.businessName === null || this.invoiceToForm.businessName === '')) {
                
                return this.$dialog.confirm('\
                    <div class="fs-larg font-weight-600 mb-4">Incomplete Invoice Information</div>\
                    <div>The invoice information is incomplete. Please update the information to proceed.</div>', {
                        customClass: 'cancelGreen okBlue cancelWide alignRight',
                        reverse: true,
                        okText: 'Invoice to End Customer',
                        cancelText: 'OK'
                })
                .then(function () {
                    self.requestPrimaveraSettings().then(data => {
                        if (data) {
                            self.invoiceToForm.vat = data.defaultEndCustomerTaxNumber;
                            self.invoiceToForm.businessName = data.defaultEndCustomerName;
                        }
                    });
                })
                .catch(err => { });
            } else {
                this.requestInvoiceEmition(isToPrint);
            }
        },
        requestInvoiceEmition(isToPrint) {
            let self = this;
            let invoiceTarget;

            if (this.invoiceTo === 'customer') {
                //is customer
                invoiceTarget = 0;
            } else {
                if (this.invoiceResume.isOTA) {
                    // is ota
                    invoiceTarget = 2;
                } else {
                    // is agent
                    invoiceTarget = 1;
                }
            }

            this.emitInvoice({
                reservationId: this.reservation.id,
                invoiceTargetType: invoiceTarget,
                documentType: this.selectedDocumentType.id,
                paymentType: parseInt(this.selectedPaymentType.id),
                client: this.invoiceToForm
            }).then(response => {
                if (response.status == 200) {
                    self.reservation.bookingInvoices.push(response.data);
                    self.$toasted.success('Document created');

                    // Save reservation
                    self.updateExistingReservation({
                        supplierId: self.account.supplierId,
                        reservation: self.reservation
                    }).then(response => {
                        if (response.status && response.status == 200) {
                            self.reservation.updateFlags = {};
                            self.eventHub.$emit('updateThisReservation', response.data);
                        }
                    })

                    // Open invoice pdf in a new tab ("Create and Print" button)
                    if (isToPrint) {
                        self.printInvoice(response.data.id).then(response => {
                            if (response.status == 200) {
                                this.openByteArrayNewTab(response.data);
                            }
                        }).catch(err => { });
                    }

                    self.closeModal();
                }
            }).catch(err => { });
        },
        updateCountry(e) {
            this.selectedCountry = e;

            if (e) {
                this.invoiceToForm.country = e.id;
            } else {
                this.invoiceToForm.country = null;
            }
        },
        setCountry(countryId) {
            if (!countryId && this.invoiceToForm.country) {
                countryId = this.invoiceToForm.country;
            }

            if (typeof countryId == "object") {
                countryId = countryId.id;
            }

            if (countryId === undefined) {
                this.selectedCountry = null;
                
                return false;
            }
            
            this.selectedCountry = this.getCountries.filter(country => {
                return country.id == countryId;
            })[0]
        },
        closeModal() {
            this.$emit('close');
        }
    },
    components: {
        vSelect: extendedVSelect,
        SellerPicker,
        Loader,
        CountryPicker
    }
}
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    .modalBg {
        z-index: 10;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);

        .modalContent {
            width: 800px;
            background-color: #FFF;
        }
    }

    .amount-input-height {
        height: 39px;
    }
</style>



// WEBPACK FOOTER //
// CreateInvoice.vue?39b4b328